import { g as $ } from "./jsx-runtime.js";
import { ab as c } from "./index2.js";
function h(u, r, e, L) {
  var d = -1, o = u == null ? 0 : u.length;
  for (L && o && (e = u[++d]); ++d < o; )
    e = r(e, u[d], d, u);
  return e;
}
var E = h;
function S(u) {
  return function(r) {
    return u == null ? void 0 : u[r];
  };
}
var W = S, _ = W, M = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, k = _(M), w = k, z = w, Z = c, D = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, I = "\\u0300-\\u036f", j = "\\ufe20-\\ufe2f", N = "\\u20d0-\\u20ff", y = I + j + N, T = "[" + y + "]", H = RegExp(T, "g");
function P(u) {
  return u = Z(u), u && u.replace(D, z).replace(H, "");
}
var G = P, J = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function V(u) {
  return u.match(J) || [];
}
var Y = V, B = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function F(u) {
  return B.test(u);
}
var q = F, t = "\\ud800-\\udfff", K = "\\u0300-\\u036f", Q = "\\ufe20-\\ufe2f", X = "\\u20d0-\\u20ff", u0 = K + Q + X, i = "\\u2700-\\u27bf", b = "a-z\\xdf-\\xf6\\xf8-\\xff", r0 = "\\xac\\xb1\\xd7\\xf7", e0 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", a0 = "\\u2000-\\u206f", d0 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", g = "A-Z\\xc0-\\xd6\\xd8-\\xde", o0 = "\\ufe0e\\ufe0f", p = r0 + e0 + a0 + d0, v = "['’]", f = "[" + p + "]", f0 = "[" + u0 + "]", R = "\\d+", x0 = "[" + i + "]", C = "[" + b + "]", m = "[^" + t + p + R + i + b + g + "]", n0 = "\\ud83c[\\udffb-\\udfff]", s0 = "(?:" + f0 + "|" + n0 + ")", c0 = "[^" + t + "]", A = "(?:\\ud83c[\\udde6-\\uddff]){2}", l = "[\\ud800-\\udbff][\\udc00-\\udfff]", a = "[" + g + "]", t0 = "\\u200d", x = "(?:" + C + "|" + m + ")", i0 = "(?:" + a + "|" + m + ")", n = "(?:" + v + "(?:d|ll|m|re|s|t|ve))?", s = "(?:" + v + "(?:D|LL|M|RE|S|T|VE))?", O = s0 + "?", U = "[" + o0 + "]?", b0 = "(?:" + t0 + "(?:" + [c0, A, l].join("|") + ")" + U + O + ")*", g0 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", p0 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", v0 = U + O + b0, R0 = "(?:" + [x0, A, l].join("|") + ")" + v0, C0 = RegExp([
  a + "?" + C + "+" + n + "(?=" + [f, a, "$"].join("|") + ")",
  i0 + "+" + s + "(?=" + [f, a + x, "$"].join("|") + ")",
  a + "?" + x + "+" + n,
  a + "+" + s,
  p0,
  g0,
  R,
  R0
].join("|"), "g");
function m0(u) {
  return u.match(C0) || [];
}
var A0 = m0, l0 = Y, O0 = q, U0 = c, L0 = A0;
function $0(u, r, e) {
  return u = U0(u), r = e ? void 0 : r, r === void 0 ? O0(u) ? L0(u) : l0(u) : u.match(r) || [];
}
var h0 = $0, E0 = E, S0 = G, W0 = h0, _0 = "['’]", M0 = RegExp(_0, "g");
function k0(u) {
  return function(r) {
    return E0(W0(S0(r).replace(M0, "")), u, "");
  };
}
var w0 = k0, z0 = w0, Z0 = z0(function(u, r, e) {
  return u + (e ? "-" : "") + r.toLowerCase();
}), D0 = Z0;
const N0 = /* @__PURE__ */ $(D0);
export {
  N0 as o
};
